// Function to toggle the description
function toggleDescription(e) {
  const btn = e.currentTarget;
  // Look for the content div specifically within the same parent
  const wrapper = btn.closest('.custom-description');
  const container = wrapper.querySelector('.description-content');

  if (!container) return;

  const isExpanded = container.classList.contains('is-expanded');

  if (isExpanded) {
    container.classList.remove('is-expanded');
    btn.textContent = 'Read more...';
    // Smooth scroll back so the user doesn't lose their place
    container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  } else {
    container.classList.add('is-expanded');
    btn.textContent = 'Close';
  }
}

// Initialize listeners
const initReadMore = () => {
  const buttons = document.querySelectorAll('.read-more-btn');
  buttons.forEach(btn => {
    // Remove existing listener to prevent double-firing
    btn.removeEventListener('click', toggleDescription);
    btn.addEventListener('click', toggleDescription);
  });
};

// Run immediately and also on a slight delay for mobile rendering
initReadMore();
setTimeout(initReadMore, 1000);